<template>
  <Main>
    <fragment v-if="form">
      <InvoiceForm
        :form="form"
        @submit="submit"
        @cancel="previousPage()"
        name-button="EDITAR FATURA"
        is-edit
        @inactivate="openModalInactivate"
        :disabled-edit="statusInactivate"
      />
    </fragment>
    <ModalGenericCriticism
      v-model="modal"
      @close="closeSubmitModal"
      :title="title"
      :text="text"
    />
    <ModalInactivateInvoice
      v-model="modalInactivate"
      @close="closeModalInactivate"
      @submit="submitInactivate"
    />
    <ModalCancelInsurance
      @close="closeModal"
      v-model="modalCancel"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>
<script>
import InvoiceForm from "../components/InvoiceForm";
import ModalGenericCriticism from "@/modules/quotation/components/ModalGenericCriticism";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import PolicyMixin from "@/mixins/PolicyMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { formatDateToDDMMYYYY } from "@/utils/formats.js";
import ModalInactivateInvoice from "../components/ModalInactivateInvoice";
import ModalCancelInsurance from "../../insurance_company/components/ModalCancelInsurance";
export default {
  beforeRouteLeave(to, from, next) {
    if (!this.statusInactivate) {
      this.modalCancel = true;
      this.nextRoute = to;
      if (this.cancel) next();
    } else {
      next();
    }
  },
  data: () => ({
    form: null,
    modal: false,
    formatDateToDDMMYYYY,
    text: null,
    title: null,
    modalInactivate: false,
    modalCancel: false,
    nextRoute: null,
    cancel: false
  }),
  components: {
    InvoiceForm,
    ModalGenericCriticism,
    ModalInactivateInvoice,
    ModalCancelInsurance
  },
  created() {
    this.fetchItems();
  },
  mixins: [LoadingRequest, PolicyMixin],
  computed: {
    ...mapState("policy", ["currentInvoice"]),
    statusInactivate() {
      return (
        this.currentInvoice.status && this.currentInvoice.status.id == "inativo"
      );
    }
  },
  methods: {
    ...mapActions("policy", [
      "requestEditInvoice",
      "requestListInsuranceCompany",
      "requestCurrentInvoice",
      "requestInactivateInvoice",
      "requestInactivateItems"
    ]),
    fetchItems() {
      this.withLoading(
        Promise.all([
          this.requestListInsuranceCompany(),
          this.requestCurrentInvoice(this.$route.params.id),
          this.requestInactivateItems()
        ])
      );
    },
    async submit(form) {
      this.withLoading(
        this.requestEditInvoice(await this.getPayloadEditInvoice(form)).then(
          () => {
            this.modal = true;
            this.title = "FATURA EDITADA";
            this.text = "A fatura foi editada com sucesso";
          }
        )
      );
    },
    async getPayloadEditInvoice(form) {
      const payload = await this.getPayloadInvoice(form);
      return {
        payload: payload,
        id: this.$route.params.id
      };
    },
    previousPage() {
      this.$router.push({ name: "policy", params: { currentTab: 1 } });
    },
    updateForm() {
      this.form = _.cloneDeep(this.currentInvoice);
      this.form.data_emissao = this.formatDateToDDMMYYYY(
        this.form.data_emissao
      );
      this.form.data_vencimento = this.formatDateToDDMMYYYY(
        this.form.data_vencimento
      );
      this.form.data_fechamento = this.formatDateToDDMMYYYY(
        this.form.data_fechamento
      );
      this.form.documentos = [this.form.arquivo];
    },
    openModalInactivate() {
      this.modalInactivate = true;
    },
    async submitInactivate(form) {
      this.withLoading(
        this.requestInactivateInvoice(
          await this.getPayloadInactivateInvoice(form)
        ).then(() => {
          this.modalInactivate = false;
          this.modal = true;
          this.title = "FATURA INATIVADA";
          this.text = "A fatura foi inativada com sucesso";
        })
      );
    },
    async getPayloadInactivateInvoice(form) {
      const payload = await this.getPayloadInactivate(form);
      return {
        payload: payload,
        id: this.$route.params.id
      };
    },
    closeModalInactivate() {
      this.modalInactivate = false;
    },
    closeModal(value) {
      this.cancel = value;
      this.modalCancel = false;
      if (value) {
        this.$router.push({
          name: this.nextRoute.name,
          params: this.nextRoute.params
        });
      }
    },
    closeSubmitModal() {
      this.modal = false;
      this.cancel = true;
      this.previousPage();
    }
  },
  watch: {
    currentInvoice() {
      this.updateForm();
    }
  }
};
</script>
